import * as actionTypes from './actionTypes';
import { PaymentActionTypes } from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { ListResults } from '../../common/List/List';
import { Payment } from '../../domain/Payment';

export type PaymentStateType = {
  paymentList: ListResults<Payment> | null;
  paymentListLoading: boolean;
  paymentListError: HttpError;
  paymentCreateLoading: boolean;
  paymentCreateError: HttpError;
  redirectUrl: string | null;
};

export type PaymentActionType = PaymentStateType & {
  type: PaymentActionTypes;
};

export const initialState: PaymentStateType = {
  paymentList: null,
  paymentListLoading: false,
  paymentListError: null,
  paymentCreateLoading: false,
  paymentCreateError: null,
  redirectUrl: null,
};

const fetchPaymentListStart = (state: PaymentStateType): PaymentStateType => ({
  ...state,
  paymentListLoading: true,
});

const fetchPaymentListSuccess = (
  state: PaymentStateType,
  action: PaymentActionType,
): PaymentStateType => ({
  ...state,
  paymentList: action.paymentList,
  paymentListLoading: false,
});

const fetchPaymentListFail = (
  state: PaymentStateType,
  action: PaymentActionType,
): PaymentStateType => ({
  ...state,
  paymentListError: action.paymentListError,
  paymentListLoading: false,
});

const createPaymentStart = (state: PaymentStateType): PaymentStateType => ({
  ...state,
  paymentCreateLoading: true,
});

const createPaymentSuccess = (
  state: PaymentStateType,
  action: PaymentActionType,
): PaymentStateType => ({
  ...state,
  paymentCreateLoading: false,
  paymentCreateError: null,
  redirectUrl: action.redirectUrl,
});

const createPaymentFail = (
  state: PaymentStateType,
  action: PaymentActionType,
): PaymentStateType => ({
  ...state,
  paymentCreateLoading: false,
  paymentCreateError: action.paymentCreateError,
});

const resetPaymentStore = (): PaymentStateType => ({
  ...initialState,
});

const logout = (): PaymentStateType => ({
  ...initialState,
});

const reducer = (state = initialState, action: PaymentActionType) => {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENT_LIST_START:
      return fetchPaymentListStart(state);
    case actionTypes.FETCH_PAYMENT_LIST_SUCCESS:
      return fetchPaymentListSuccess(state, action);
    case actionTypes.FETCH_PAYMENT_LIST_FAIL:
      return fetchPaymentListFail(state, action);
    case actionTypes.CREATE_PAYMENT_START:
      return createPaymentStart(state);
    case actionTypes.CREATE_PAYMENT_SUCCESS:
      return createPaymentSuccess(state, action);
    case actionTypes.CREATE_PAYMENT_FAIL:
      return createPaymentFail(state, action);
    case actionTypes.RESET_PAYMENT_STORE:
      return resetPaymentStore();
    case actionTypes.LOGOUT:
      return logout();
    default:
      return state;
  }
};

export default reducer;
